import type { Entries } from './catalog';

/**
 * The copy of an outage said once (D163): who did not answer, from the family's catalog of causes
 * (D133), what each read is, said only in the notice's Technical details, and the name of a place opened
 * before anything of it could be read (`place.*`, its H1). "Not available right now", "Last updated
 * 12:04", the last-tried line and Try again are `@beyond-js/ui`'s own words.
 *
 * Each area keeps its own file so its keys travel with its screens; a key here must not repeat one of
 * `en.ts`, `es.ts` or another area.
 */
export const outage: Record<'en' | 'es', Entries> = {
	en: {
		'outage.accounts': 'Beyond Accounts did not answer',
		'outage.unreached': 'Beyond Accounts could not be reached',
		'state.check': 'Check this page',
		'outage.session': 'Your session',
		'outage.methods': 'Sign-in methods',
		'outage.request': 'The app’s request',
		'outage.invitation': 'The invitation',
		'outage.products': 'Products',
		'outage.organization': 'Members and invitations',
		'outage.closing': 'Organizations scheduled for deletion',
		'outage.older': 'Older activity',
		'outage.holdings': 'What the products hold',
		'place.accounts': 'Beyond Accounts',
		'place.consent': 'Sign-in request',
		'place.connect': 'Connection request',
		'place.invitation': 'Invitation'
	},
	es: {
		'outage.accounts': 'Beyond Accounts no respondió',
		'outage.unreached': 'No se pudo contactar con Beyond Accounts',
		'state.check': 'Revisar esta página',
		'outage.session': 'Tu sesión',
		'outage.methods': 'Métodos de inicio de sesión',
		'outage.request': 'La solicitud de la app',
		'outage.invitation': 'La invitación',
		'outage.products': 'Productos',
		'outage.organization': 'Miembros e invitaciones',
		'outage.closing': 'Organizaciones programadas para eliminarse',
		'outage.older': 'Actividad anterior',
		'outage.holdings': 'Lo que tienen los productos',
		'place.accounts': 'Beyond Accounts',
		'place.consent': 'Solicitud de inicio de sesión',
		'place.connect': 'Solicitud de conexión',
		'place.invitation': 'Invitación'
	}
};
